import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Select } from '../../../forms/select';
import messages from './AutomaticRepaymentsQuestion.messages';
import styles from './AutomaticRepaymentsQuestion.module.css';
import { repaymentOptions } from './AutomaticRepaymentsQuestion.options';

type TOption = { icon: any; label: string; description: string; value: any };

export class AutomaticRepaymentsQuestion extends Component<{
    selectRepaymentRole: (arg: string) => void;
}> {
    renderOption(option: TOption) {
        return (
            <>
                <div className={styles.optionTitle}>
                    <div className={styles.optionIcon}>{option.icon}</div>
                    <div className={styles.optionLabel}>{option.label}</div>
                </div>
                <div className={styles.optionDescription}>
                    {option.description}
                </div>
            </>
        );
    }

    renderValue(option: TOption) {
        return (
            <div className={styles.valueTitle}>
                <div className={styles.valueIcon}>{option.icon}</div>
                <div className={styles.valueText}>{option.label}</div>
            </div>
        );
    }

    handleOnSelectChange = (option: TOption, input: any) => {
        this.props.selectRepaymentRole(option.value);
        input.onChange(option.value);
    };

    render() {
        return (
            <Select
                className={styles.AutomaticRepayments}
                name="repaymentRole"
                label={<FormattedMessage {...messages.repaymentRole} />}
                {...this.props}
                selectOptions={{
                    optionRenderer: this.renderOption,
                    valueRenderer: this.renderValue,
                    options: repaymentOptions,
                    onSelect: this.handleOnSelectChange
                }}
            />
        );
    }
}
